<script lang="ts">
export default {
    name: 'IconContactUs',
    props: {
        /**
         * Width
         */
        width: {
            type: String,
            default: '32px',
            required: false,
        },
        /**
         * Height
         */
        height: {
            type: String,
            default: '32px',
            required: false,
        },
    },
};
</script>

<template>
    <svg
        :style="{
            height: height,
            width: width,
        }"
        viewBox="0 0 32 32"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M29.5901 7.05046C29.5004 7.00561 29.3995 6.99439 29.3042 7.01121C29.2874 7.01121 29.265 7 29.2481 7H2.61673C2.61673 7 2.57748 7.00561 2.55505 7.01121C2.45974 7 2.36443 7.00561 2.26912 7.05046C2.10092 7.12895 2 7.29715 2 7.48217V24.1562C2 24.4197 2.21305 24.6328 2.47656 24.6328H29.3883C29.5173 24.6328 29.635 24.5879 29.7247 24.4926C29.8144 24.4029 29.8649 24.2796 29.8649 24.1562V7.48217C29.8649 7.29715 29.7583 7.12895 29.5901 7.05046V7.05046ZM27.9138 7.95873L15.9324 17.7535L3.9511 7.95873H27.9138V7.95873ZM28.9117 23.6797H2.95312V8.48575L15.6297 18.8187C15.8035 18.9589 16.0558 18.9589 16.2296 18.8187L28.9117 8.48575V23.6797Z" />
    </svg>
</template>
